// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"954":"72288d2e","980":"633875f9"}[chunkId] + ".chunk.js";
};